import React, {FC, useEffect, useRef, useState} from 'react';
import { Card, CardBody, Col } from 'reactstrap';
// import {defFilter}from "./SupplierRedemptionSubFilter";
import SupplierRedemptionTable from "../../../../../Reports/SupplierRedemption/components/SupplierRedemptionTable";
import axios from "axios";
import {isEmpty} from '@/shared/helpers'
import { getAllPrograms } from '@/shared/apiHelper.jsx';
import {CSVLink} from "react-csv";

interface SupplierRedemptionIndexProps
{
    programid?: any
}

const SupplierRedemptionIndex: FC<SupplierRedemptionIndexProps> = ({programid}) => {
    const [merchants, setMerchants] = useState([]);
    const [defaultMerchants, setDefaultMerchants] = useState([]);
    const [programs, setPrograms] = useState([]);

    const getData = async () => {
        const merchantsApiUrl = `/organization/1/merchant?page=0&limit=9999999999&minimal=1`
        if (isEmpty(merchants)) {
            try {
                const response = await axios.get(merchantsApiUrl);
                if (response.data.length === 0) return {results: [], count: 0}
                const data = response.data;
                setMerchants(data);
                return data;
            } catch (e) {

            }
        }
    }

    useEffect(() => {
        getData();
        if (merchants) {
            const result = merchants.map(x => x.id)
            setDefaultMerchants(result);
        }
    }, [merchants])

    // Why: the report scopes by the program that redeemed, and a redemption is
    //      recorded against the leaf the participant was logged into — so "this
    //      program" on this page means the whole subtree it was opened on.
    // Scope: resolves the subtree once per program; the table sends it on every
    //        request. Nothing here decides what the API does with the list.
    // SRP: turns one program id into the list of account holder ids the report
    //      is scoped to.
    useEffect(() => {
        const resolveSubtree = async () => {
            const response = await getAllPrograms("minimal=true&limit=99999999&programId=" + programid);
            const data = response?.data ?? [];
            setPrograms(data.map(x => x.account_holder_id));
        }
        resolveSubtree();
    }, [programid])

    if (isEmpty(defaultMerchants) || isEmpty(programs)) {
        return <p>Loading...</p>;
    }

    return (
        <Col md={12}>
            <Card>
                <CardBody>
                    <SupplierRedemptionTable merchants={defaultMerchants} programs={programs}/>
                </CardBody>
            </Card>
        </Col>
    )
}

export default SupplierRedemptionIndex;
